import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import classNames from 'classnames';
import Heading from '../../components/heading';
import withAuthProvider from '../../hoc/withAuthProvider';
import withFetch from '../../hoc/withFetch';
import SpinnerDots from '../../components/spinner/dots';
import Takeover from '../../components/takeover';
import Success from '../../components/spinner/success';
import { REACT_APP_API_BASE } from '../../config';
import './styles.scss';

class Monitor extends Component {

    state = {
        isLoading: true,
        watcherTasks: null,
        isDeleteOpen: false,
        isDeleting: false,
        isDeleteFinished: false,
        currentWatcher: null,
        type:  null
    };

    async fetchWatcherTasks() {
        const res = await this.props.fetch(`${REACT_APP_API_BASE}/online/watchertasks`);
       return await res.json();
    }

    async componentDidUpdate() {
        if (!this.props.isAuthenticated) return;

        if (this.state.watcherTasks) return;

        const watcherTasks = await this.fetchWatcherTasks();

        this.setState({
            isLoading: false,
            watcherTasks
        });
    }

    async getTokenHeaders() {
        const token = await this.props.getAccessToken();
        const headers = new Headers();
        const bearer = `Bearer ${token}`;
        headers.append('Authorization', bearer);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');

        return headers;
    }

    async delete(id, type) {
        this.setState({
            isDeleting: true
        });

        const headers = await this.getTokenHeaders();

        const rawResponse = await fetch(type === 'units/search' ? `${REACT_APP_API_BASE}/${type}/adddeletewatch` : `${REACT_APP_API_BASE}/${type}/${id}/adddeletewatch`, {
            method: 'POST',
            headers: headers,
            body: type === 'units/search' ? JSON.stringify({
                ...this.state.currentWatcher
            }) : JSON.stringify({})
        });

        if (rawResponse.ok) {
            this.setState({
                isLoading: true,
                isDeleting: false,
                isDeleteFinished: true
            });

            const watcherTasks = await this.fetchWatcherTasks();

            this.setState({
                isLoading: false,
                watcherTasks
            });
        }
    }

    toggleDeleteDialog(currentWatcher, type) {
        if (this.state.isDeleting) return;

        this.setState({
            isDeleteOpen: !this.state.isDeleteOpen,
            currentWatcher,
            type
        }, () => {
            setTimeout(() => {
                this.setState({
                    isDeleteFinished: false
                });    
            }, 300);
            
        });        
    }

    render() {

        return (
            <Router>
                <section className={classNames({
                    'monitor': true,
                    'monitor--is-loading': this.state.isLoading
                })}>
                    <Heading heading="Bevakningar">
                        {/*
                            {!this.state.isLoading &&
                                <ul className="monitor__tabs">
                                    <li><Link to="/myfeed" activeClassName="monitor__tabitem--selected" exact={true}>Enheter</Link></li>
                                    
                                    <li><Link to="/myfeed/searches" activeClassName="monitor__tabitem--selected">Sökningar</Link></li>
                                    <li><Link to="/myfeed/districts" activeClassName="monitor__tabitem--selected">Säljdistrikt</Link></li>
                            
                                </ul>
                            }
                        */}
                    </Heading>
                    <div className="monitor__table-wrapper">
                        <div className="monitor__table-content">
                            <Switch>
                                <Route path="/myfeed" exact={true}>
                                    {this.props.roles.menuItems.indexOf('Delfiregister') > -1 &&
                                        <div className="monitor__content-inner monitor__content-inner--no-padding">
                                            <div className="monitor__table-wrapper-inner">
                                                {(!this.state.isLoading && this.state.watcherTasks && this.state.watcherTasks.units.length > 0) &&
                                                    <table className="table">
                                                        <thead>
                                                            <tr>
                                                                <th>BUTIKER</th>
                                                                <th>DELFI-ID</th>
                                                                <th>SENAST ÄNDRAD</th>
                                                                <th>SENAST KONTROLLERAD</th>
                                                                <th></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {this.state.watcherTasks.units.map(unit => {
                                                                return (
                                                                    <tr key={unit.delfiId}>
                                                                        <td><a href={`/unit/${unit.delfiId}`}>{unit.unitName}</a></td>
                                                                        <td>{unit.delfiId}</td>
                                                                        <td>{unit.itemLastUpdated}</td>
                                                                        <td>{unit.watcherLastUpdated}</td>
                                                                        <td>
                                                                            <button className="monitor__delete" onClick={() => this.toggleDeleteDialog({
                                                                                ...unit,
                                                                                id: unit.delfiId,
                                                                                name: unit.unitName
                                                                             }, 'units')} type="button"></button>
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            })}
                                                        </tbody>
                                                    </table>
                                                }
                                                {(!this.state.isLoading && this.state.watcherTasks && this.state.watcherTasks.units.length === 0) &&
                                                    <div className="monitor__no-hits">
                                                        <p>👋 Hej! Du bevakar inga enheter än. Ta en titt 🔦 <a href="/search">här</a> om du kan hitta någon! 🏠</p>
                                                    </div>
                                                }
                                            </div>
                                            
                                        </div>
                                    }

                                    {this.props.roles.menuItems.indexOf('Delfiregister') === -1 &&
                                         <div className="monitor__content-inner monitor__content-inner--no-padding">
                                             <div className="monitor__no-hits">
                                                <p>👋 Hej! Delfiregister ingår inte i ditt abonnemang. <a href="mailto:info@delfi.se">Kontakta Delfi</a> för att få tillgång till delfiregistret.</p>
                                            </div>
                                         </div>
                                    }
                                </Route>
                                <Route path="/myfeed/searches">
                                    {this.props.roles.menuItems.indexOf('Delfiregister') > -1 &&
                                        <div className="monitor__content-inner monitor__content-inner--no-padding">
                                            <div className="monitor__table-wrapper-inner">
                                                {(!this.state.isLoading && this.state.watcherTasks && this.state.watcherTasks.unitSearchItems.length > 0) &&
                                                    <table className="table">
                                                        <thead>
                                                            <tr>
                                                                <th>BUTIKER</th>
                                                                <th>SENAST ÄNDRAD</th>
                                                                <th>SENAST KONTROLLERAD</th>
                                                                <th></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {this.state.watcherTasks.unitSearchItems.map(unitSearch => {
                                                                return (
                                                                    <tr key={unitSearch.watcherId}>
                                                                        <td><a href={`/search?${unitSearch.searchParameters}`}>{unitSearch.watcherName}</a></td>
                                                                        <td>{unitSearch.itemLastUpdated}</td>
                                                                        <td>{unitSearch.watcherLastUpdated}</td>
                                                                        <td className="monitor__item-controls">
                                                                            {/*<button className="monitor__edit" type="button"></button>*/}
                                                                            <button className="monitor__delete" onClick={() => this.toggleDeleteDialog(unitSearch, 'units/search')} type="button"></button>
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            })}
                                                        </tbody>
                                                    </table>
                                                }
                                                {(!this.state.isLoading && this.state.watcherTasks && this.state.watcherTasks.unitSearchItems.length === 0) &&
                                                    <div className="monitor__no-hits">
                                                        <p>👋 Hej! Du inga sparade sökningar. Du kan göra en ny sökning <a href="/search">här.</a>! 🔦</p>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    }
                                    {this.props.roles.menuItems.indexOf('Delfiregister') === -1 &&
                                         <div className="monitor__content-inner monitor__content-inner--no-padding">
                                             <div className="monitor__no-hits">
                                                <p>👋 Hej! Delfiregister ingår inte i ditt abonnemang. <a href="mailto:info@delfi.se">Kontakta Delfi</a> för att få tillgång till delfiregistret.</p>
                                            </div>
                                         </div>
                                    }
                                </Route>
                                <Route path="/myfeed/districts">
                                    <h1>Bevakade säljdistrikt</h1>
                                </Route>
                            </Switch>

                            <SpinnerDots />
                        </div>
                    </div>
                    <Takeover isOpen={this.state.isDeleteOpen} 
                        toggleTakeover={() => this.toggleDeleteDialog()} 
                        heading={this.state.isDeleteFinished ? 'Klart!' : 'Ta bort bevakning' }
                        modifiers={{
                            'takeover--no-margin': true
                        }}>
                            <div className={classNames({
                                'monitor__delete-dialog': true,
                                'monitor__delete-dialog--is-deleting': this.state.isDeleting,
                                'monitor__delete-dialog--is-finished': this.state.isDeleteFinished
                            })}>
                                {!this.state.isDeleteFinished &&
                                    <>
                                        <div className="districts__edit-confirm">
                                            <p>Vill du ta bort bevakningen av <strong>{this.state.currentWatcher && this.state.currentWatcher.name}</strong>?</p>
                                            <div className="districts__edit-confirm-buttons">
                                                <button type="button" onClick={() => this.delete(this.state.currentWatcher && this.state.currentWatcher.id, this.state.type)} className="districts__takeover-controls-btn districts__takeover-controls-btn--danger">Ta bort</button>
                                                <button onClick={() => this.toggleDeleteDialog()} type="button" className="districts__takeover-controls-btn districts__takeover-controls-btn--outline">Avbryt</button>
                                            </div>
                                        </div>
                                        <SpinnerDots />
                                    </>
                                }
                                {this.state.isDeleteFinished &&
                                    <>
                                        <Success isFinished={this.state.isDeleteFinished} />
                                        <div className="districts__takeover-controls">
                                            <button onClick={() => this.toggleDeleteDialog()} className="districts__takeover-controls-btn districts__takeover-controls-btn--outline" type="button">Stäng</button>
                                        </div>
                                    </>
                                }
                            </div>
                    </Takeover>
                </section>
            </Router>
        );
    }
};

export default withAuthProvider(withFetch(Monitor));

